import axios from "axios";
import config, { API_JAVA } from '../config';
const BASE_URL = API_JAVA;


class NCALayerModuleService {

    save(result) {
        return axios.post(`${BASE_URL}/nm/save`,   result );
    }

}

export default new NCALayerModuleService();
